import {
  createLowCodePopupRequestId,
  getLowCodePopupPageConfig,
  getPlatformPopupConfig,
  invokeNativeLowCodePopup,
  isLowCodePopupPageAction,
  normalizePopupSize,
  resolveLowCodeRuntimePlatform,
  resolvePopupTitle,
} from "@/utils/lowCodePopupPage.js";

function createEmptyPopupState() {
  return {
    active: false,
    visible: false,
    native: false,
    requestId: "",
    title: "",
    pageId: "",
    pageTitle: "",
    platform: "pc",
    presentation: null,
    parentContext: {},
    result: undefined,
  };
}

export function useLowCodeActionRuntime() {
  const popupState = useState("low-code-popup-page-state", createEmptyPopupState);
  const { locale } = useI18n();

  function closeLowCodePopup(result) {
    popupState.value = {
      ...createEmptyPopupState(),
      result,
    };
  }

  function dispatchLowCodeAction(action, context = {}) {
    if (!isLowCodePopupPageAction(action)) return false;
    const popupConfig = getLowCodePopupPageConfig(action);
    const platform = resolveLowCodeRuntimePlatform(context);
    const platformConfig = getPlatformPopupConfig(popupConfig, platform);
    if (!platformConfig?.pageId) {
      console.error("low code popup page is missing pageId", {
        platform,
        action,
      });
      return false;
    }

    const requestId = createLowCodePopupRequestId();
    const title = resolvePopupTitle(
      popupConfig,
      context,
      locale.value || "zh-CN"
    );
    const presentation = {
      placement: ["center", "bottom", "side"].includes(
        platformConfig.placement
      )
        ? platformConfig.placement
        : platform === "pc"
          ? "center"
          : "bottom",
      width: normalizePopupSize(
        platformConfig.width,
        platform === "pc"
          ? { value: 960, unit: "px" }
          : { value: 100, unit: "%" }
      ),
      height: normalizePopupSize(
        platformConfig.height,
        platform === "pc"
          ? { value: 720, unit: "px" }
          : { value: 80, unit: "vh" }
      ),
      maskClosable: false,
    };

    const nextState = {
      active: true,
      visible: true,
      native: false,
      requestId,
      title,
      pageId: platformConfig.pageId,
      pageTitle: platformConfig.pageTitle || "",
      platform,
      presentation,
      parentContext: context || {},
      result: undefined,
    };

    if (platform === "app") {
      const nativePayload = {
        command: "openLowCodePopupPage",
        version: 1,
        requestId,
        title,
        pageId: platformConfig.pageId,
        pageUrl: platformConfig.pageUrl || "",
        presentation,
        locale: locale.value || "zh-CN",
      };
      if (invokeNativeLowCodePopup(nativePayload)) {
        popupState.value = {
          ...nextState,
          visible: false,
          native: true,
        };
        return true;
      }
    }

    popupState.value = nextState;
    return true;
  }

  return {
    popupState,
    closeLowCodePopup,
    dispatchLowCodeAction,
  };
}
